import React from "react";
import { connect } from "react-redux";
import Select from "react-dropdown-select";
import "../Forms/css/register.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import axios from "axios";

const token = localStorage.getItem('authToken');

const countries = [
    { label: 'UK (+44)', value: 'UK (+44)' },
    { label: 'USA (+1)', value: 'USA (+1)' },
    { label: 'Canada (+1)', value: 'Canada (+1)' },
    { label: 'Australia (+61)', value: 'Australia (+61)' },
    { label: 'India (+91)', value: 'India (+91)' },
    // Add more countries as needed
];

class AddAttributes extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            name: '',

          

            submissionStatus: null,
        };
    }

    handleChange = (e) => {
        const { name, value } = e.target;
        this.setState({ [name]: value });
    };

    handleSubmit = async (e) => {
        e.preventDefault();
        
        // Create a JSON object from the state
        const jsonData = { ...this.state };
    
        try {
            const config = {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}` // Ensure token is correctly set
                }
            };
    
            // Post JSON data instead of FormData
            const response = await axios.post("https://brand.aasmo.in/api/superadmin/attribute", jsonData, config);
    
            console.log('Response:', response);
    
            if (response && response.status === 201) {
                this.setState({ submissionStatus: 'success' });
                console.log('Form submitted successfully');
                setTimeout(() => {
                    window.location.href = "/list-attribute";
                }, 2000);
            } else {
                console.log('Unexpected response:', response);
            }
    
        } catch (error) {
            console.error('Error submitting form:', error);
    
            if (error.response) {
                const { status, data } = error.response;
                if (status === 400) {
                    console.error('Bad request error:', data);
                } else if (status === 401) {
                    console.error('Unauthorized error, please log in again.');
                } else {
                    console.error('Error response:', error.response);
                }
            } else {
                console.error('Network or other error:', error);
            }
        }
    };
    

    render() {
        const { submissionStatus } = this.state;
        return (
            <div className="col-md-12">
                <form onSubmit={this.handleSubmit}>
                    <div className="card">
                        <div className="header">
                            <h2>Add Attributes</h2>
                        </div>
                        <div className="card-body">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="form-group">
                                        <label>Name</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="name"
                                            value={this.state.name}
                                            onChange={this.handleChange}
                                            placeholder="First Name"
                                        />
                                    </div>

                               
                                    {submissionStatus === 'success' && (
                                        <div className="alert alert-success" role="alert">
                                            Form submitted successfully!
                                        </div>
                                    )}
                                    <button
                                        className="btn btn-primary"
                                        onClick={(e) => {
                                            this.setState({ submeet: true });

                                            this.handleSubmit(e)

                                        }}
                                    >
                                        Submit
                                    </button>
                                </div>

                            </div>
                        </div>






                    </div>
                </form>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({});

export default connect(mapStateToProps, {})(AddAttributes);
